import { Box, BoxProps } from "@chakra-ui/react";
import { FiPrinter } from "react-icons/fi";

export const PrinterIcon = (props: BoxProps) => {
  return <Box as={FiPrinter} height="20px" width="20px" {...props} />;
};
